import { action, computed, makeObservable, observable } from "mobx";

export type ViewModeType = "add" | "edit" | "read";

export class ViewModeManager {
    public _mode: ViewModeType = "read";

    constructor(initialMode: ViewModeType = "read") {
        makeObservable(this, {
            _mode: observable,

            switchToAddMode: action,
            switchToEditMode: action,
            switchToReadMode: action,
            setViewMode: action,

            isAddMode: computed,
            isEditMode: computed,
            isReadMode: computed,
            mode: computed,
        });

        if (initialMode) {
            this._mode = initialMode;
        }
    }

    public switchToAddMode = () => {
        this._mode = "add";
    };
    public switchToEditMode = () => {
        this._mode = "edit";
    };
    public switchToReadMode = () => {
        this._mode = "read";
    };

    public setViewMode = (mode: ViewModeType) => {
        this._mode = mode;
    };

    public get isAddMode(): boolean {
        return this._mode === "add";
    }

    public get isEditMode(): boolean {
        return this._mode === "edit";
    }

    public get isReadMode(): boolean {
        return this._mode === "read";
    }

    public get mode(): ViewModeType {
        return this._mode;
    }
}
